module.exports = __webpack_public_path__ + "img/manager.6a00f97d.png";